import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {Member} from '@/app/core/models/member';

@Injectable({
	providedIn: 'root'
})
export class MemberService {

	constructor(
		private readonly http: HttpClient
	) {}

	getActiveMembers(rosterType: string): Observable<Record<string, Member[]>> {
		return this.http.get<Record<string, Member[]>>(`${environment.backendUrl}/member/roster/` + rosterType + '/active');
	}

	getMemberById(id: string): Observable<Member> {
		return this.http.get<Member>(`${environment.backendUrl}/member/${id}`);
	}

	getVgcMember(rosterType: string): Observable<Member[]> {
		return this.http.get<Member[]>(`${environment.backendUrl}/member/vgc`);
	}
}
